/* =========================================================
   ZALOOQ — BOLD MOTION LAYER (JS)
   Vanilla JS only, no dependencies. Two small jobs:
   1. Fade/slide sections into view on scroll (IntersectionObserver)
   2. Add a "scrolled" class to <body> for the header shadow
   Both skip entirely if the visitor prefers reduced motion.
   ========================================================= */
(function () {
  "use strict";

  var prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;

  /* ---- 1. Scroll reveal ---- */
  function initScrollReveal() {
    var targets = document.querySelectorAll(
      "product-list .product-card, " +
      "collection-list .collection-card, " +
      "main section, " +
      ".collection-list__item"
    );

    if (!targets.length) return;

    if (prefersReducedMotion || !("IntersectionObserver" in window)) {
      targets.forEach(function (el) {
        el.classList.add("zlq-visible");
      });
      return;
    }

    targets.forEach(function (el) {
      el.classList.add("zlq-reveal");
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("zlq-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -40px 0px" }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ---- 2. Header scroll shadow ---- */
  function initHeaderScroll() {
    var ticking = false;

    function update() {
      if (window.scrollY > 12) {
        document.body.classList.add("zlq-scrolled");
      } else {
        document.body.classList.remove("zlq-scrolled");
      }
      ticking = false;
    }

    window.addEventListener(
      "scroll",
      function () {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );

    update();
  }

  function init() {
    initScrollReveal();
    initHeaderScroll();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
